import { LogoPropsType } from './logoTypes';

export default function EricssonLogo({ className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 300 61" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <title id="ericssonLogoTitle">Ericsson</title>
      <g clipPath="url(#clip0_4178_119092)">
        <path
          d="M0.599976 19.002H24.8V25.6036H9.15998V31.3424H24.16V38.2049H9.15998V44.1243H25.06V50.7862H0.599976V19.002Z"
          fill="#808080"
        />
        <path d="M62.46 19.002H71.08V50.8062H62.46V19.002Z" fill="#808080" />
        <path
          d="M102.54 20.0266L101.96 26.8289C94.9999 22.7757 84.3199 24.0799 84.1399 34.6747C83.9399 45.2694 95.1399 46.8145 102.22 43.2227L102.66 50.1655C90.1399 54.0783 75.1799 50.1053 75.2399 34.6747C75.2999 19.5651 90.3799 15.3914 102.54 20.0266Z"
          fill="#808080"
        />
        <path
          d="M127.92 19.5241L127.34 26.1458C123 23.7379 114.74 23.6777 114.74 27.4501C114.74 33.0284 129.44 28.9951 129.44 40.9544C129.44 52.7129 115.44 52.8333 106.36 50.1244L107 43.1215C112.68 45.7902 120.74 46.3721 120.74 41.757C120.74 36.7004 105.98 39.5497 105.98 28.1724C105.98 18.8419 117.5 16.3537 127.92 19.5241Z"
          fill="#808080"
        />
        <path
          d="M153.92 19.5241L153.34 26.1458C149 23.7379 140.74 23.6777 140.74 27.4501C140.74 33.0284 155.44 28.9951 155.44 40.9544C155.44 52.7129 141.44 52.8333 132.36 50.1244L133 43.1215C138.68 45.7902 146.74 46.3721 146.74 41.757C146.74 36.7004 131.98 39.5497 131.98 28.1724C132 18.8419 143.5 16.3537 153.92 19.5241Z"
          fill="#808080"
        />
        <path
          d="M193.62 19.002H204.54L214.94 39.5092V19.002H222.88V50.8062H212.58L201.62 29.8977V50.8062H193.62V19.002Z"
          fill="#808080"
        />
        <path
          d="M173.74 18.2402C182.7 18.2402 189.52 23.4975 189.52 34.9751C189.52 45.9511 182.66 51.5896 173.74 51.5896C164.84 51.5896 158 46.0715 158 34.9751C158.02 23.4975 164.8 18.2402 173.74 18.2402ZM166.84 34.9751C166.84 39.831 168.92 45.309 173.74 45.309C178.58 45.309 180.6 39.831 180.64 34.9751C180.68 30.6008 178.58 24.6613 173.74 24.6412C168.92 24.6412 166.84 30.1192 166.84 34.9751Z"
          fill="#808080"
        />
        <path
          d="M39.3199 32.4059H44.0399C46.1599 32.446 48.0799 31.1618 48.0599 28.8141C48.0399 26.7273 46.3399 25.2625 44.1599 25.2825H39.2999L39.3199 32.4059ZM31.0599 19.002H46.5999C50.8199 19.002 56.6999 20.8681 56.6999 27.4697C56.6999 31.7036 54.7799 34.0714 51.1599 35.1549C51.3199 35.1348 53.2399 35.9776 54.0199 38.3654C54.0599 38.4457 58.4599 50.7862 58.5199 50.8062H49.3599L46.0999 41.2549C45.5999 39.7901 44.5199 38.8069 42.9599 38.8069C41.6199 38.8069 39.4999 38.7266 39.4999 38.8069V50.8062H31.0599V19.002Z"
          fill="#808080"
        />
        <path
          d="M299.1 4.39463C298.6 2.84957 297.5 1.64562 296.14 0.963381C294.78 0.281144 293.18 0.120618 290.5 1.02358L260.18 11.1568C257.52 12.0397 256.32 13.1433 255.64 14.5078C254.96 15.8723 254.8 17.4775 255.32 19.0427C255.82 20.5877 256.92 21.7917 258.28 22.4739C259.64 23.1561 261.24 23.3167 263.92 22.4137L294.24 12.2805C296.9 11.3976 298.1 10.294 298.78 8.9295C299.46 7.56503 299.62 5.95976 299.1 4.39463Z"
          fill="#808080"
        />
        <path
          d="M299.1 23.1759C298.6 21.6308 297.5 20.4269 296.14 19.7446C294.78 19.0624 293.18 18.9019 290.5 19.8048L260.18 29.9381C257.52 30.8209 256.32 31.9246 255.64 33.289C254.96 34.6535 254.8 36.2588 255.32 37.8239C255.82 39.369 256.92 40.5729 258.28 41.2552C259.64 41.9374 261.24 42.0979 263.92 41.195L294.24 31.0617C296.9 30.1788 298.1 29.0752 298.78 27.7108C299.46 26.3463 299.62 24.741 299.1 23.1759Z"
          fill="#808080"
        />
        <path
          d="M299.1 41.9571C298.6 40.4121 297.5 39.2081 296.14 38.5259C294.78 37.8436 293.18 37.6831 290.5 38.5861L260.18 48.7193C257.52 49.6022 256.32 50.7058 255.64 52.0703C254.96 53.4348 254.8 55.04 255.32 56.6052C255.82 58.1502 256.92 59.3542 258.28 60.0364C259.64 60.7186 261.24 60.8792 263.92 59.9762L294.24 49.843C296.9 48.94 298.1 47.8565 298.78 46.492C299.46 45.1275 299.62 43.5223 299.1 41.9571Z"
          fill="#808080"
        />
      </g>
      <defs>
        <clipPath id="clip0_4178_119092">
          <rect width="300" height="61" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
